
import { SearchContext, SearchKey } from "@/composables/useSearch";
import { defineComponent, inject } from "vue";

export default defineComponent({
  setup() {
    const { category } = inject(SearchKey) as SearchContext;

    return { category };
  },
});
